<template>
  <MainLayout>
    <PageHeader
      icon="ri-arrow-up-circle-line"
      title="Solicitar Avance de Nivel"
      subtitle="Gestiona tu solicitud de avance al siguiente nivel"
      :show-button="false" />

    <div class="content-card mt-4 mb-4">
      <!-- Paso 1: Solicitud de avance con selección de sede -->
      <div v-if="paso == 1" class="step-content">
        <div class="message-box" v-html="mensaje"></div>

        <div v-if="nivel_siguiente && nivel_siguiente.descripcion" class="nivel-info">
          <strong>Nivel siguiente:</strong> {{ nivel_siguiente.descripcion }}
        </div>

        <div v-if="nivel_siguiente && nivel_siguiente.descripcion && !virtual" class="form-section">
          <label for="sede_id" class="asw-form-label">
            <i class="ri-map-pin-line"></i>
            ¿En qué sede deseas reclamar el siguiente libro?
          </label>
          <select v-model="sede_id" id="sede_id" class="asw-select">
            <option disabled :value="null">Selecciona una sede</option>
            <option v-for="opcion in sedesFiltradas" :value="opcion.id" :key="opcion.id">
              {{ opcion.nombre }}
            </option>
          </select>
        </div>

        <div v-if="nivel_siguiente && nivel_siguiente.descripcion" class="confirmation-section">
          <p class="confirmation-text">
            ¿Deseas continuar tu solicitud de avance de nivel?
          </p>
          <div class="button-group">
            <b-btn variant="danger" @click="regresar()">
              <i class="ri-close-line"></i> Cancelar
            </b-btn>
            <b-btn variant="success" @click="procesar()" :disabled="procesando || !completo">
              <i class="ri-check-line"></i> Continuar
            </b-btn>
          </div>
        </div>

        <div v-if="!nivel_siguiente" class="button-group centered">
          <b-btn variant="primary" @click="regresar()">
            <i class="ri-check-line"></i> Aceptar
          </b-btn>
        </div>
      </div>

      <!-- Paso 5: Mensaje de inasistencia -->
      <div v-else-if="paso == 5" class="step-content">
        <div class="message-box error" v-html="mensaje"></div>
        <div class="button-group centered">
          <b-btn variant="danger" @click="continuar(1)">
            <i class="ri-logout-box-line"></i> Salir
          </b-btn>
        </div>
      </div>

      <!-- Otros pasos: Mensajes generales -->
      <div v-else class="step-content">
        <div class="message-box" v-html="mensaje"></div>
        <div class="button-group centered">
          <b-btn variant="primary" @click="regresar()">
            <i class="ri-check-line"></i> Aceptar
          </b-btn>
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { validationMixin } from 'vuelidate'
import MainLayout from '@/components/Layout/MainLayout.vue';
import PageHeader from '@/components/Layout/PageHeader.vue';

export default {
  mixins: [validationMixin],
  name: 'AvanzarNivelPage',
  components: {
    MainLayout,
    PageHeader
  },
  data() {
    return {
      nivel_siguiente: null,
      paso: 1,
      sede_id: null,
      mensaje: null,
      form: null,
      procesando: false,
      codigo: null,
      virtual: false
    }
  },
  mounted() {
    this.cursoFinalizado();
    if (!this.sedes || (this.sedes && this.sedes.length == 0)) {
      this.fetchSedes()
      setTimeout(() => {
        this.establecerSedes();
      }, 500);
    } else {
      this.establecerSedes();
    }
  },
  methods: {
    ...mapActions({
      fetchDisponibilidad: 'academico/fetchDisponibilidad',
      fetchCursoFinalizado: 'academico/fetchCursoFinalizado',
      fetchCursoActual: 'academico/fetchCursoActual',
      fetchTipos: 'academico/fetchTipos',
      fetchSedes: 'sedes/fetchLista',
      fetchInformacion: 'student/informacion',
      avanzarNivel: 'academico/avanzarNivel',
      fetchSedeActual: 'academico/fetchSedeActual',
    }),
    ...mapMutations({
      setShowNotification: 'setShowNotification',
      startProcessing: 'startProcessing',
      stopProcessing: 'stopProcessing',
      setWarning: 'setWarning'
    }),
    regresar() {
      this.$router.push(`/`)
    },
    continuar(paso) {
      this.paso = paso;
      if (paso === 1) {
        this.$router.push(`/`)
      }
    },
    procesar() {
      if (!['ok', 'ok_update'].includes(this.codigo)) {
        this.setWarning('No puede realizar esta acción');
        return;
      }
      this.startProcessing();
      this.procesando = true;
      var curso = { nivel_id: null, sede_id: null }
      if (this.codigo == 'ok') {
        curso.nivel_id = this.nivel_siguiente.id;
        curso.sede_id = this.sede_id;
      }

      this.avanzarNivel(curso).then((result) => {
        this.stopProcessing();
        if (result.codigo != 'ok') {
          this.procesando = false;
        }
        if (result && result.mensaje) {
          this.setWarning(result.mensaje);
          setTimeout(() => {
            this.fetchSedeActual()
            this.fetchCursoActual().then(() => {
              this.$router.push(`/`)
            })
          }, 3000)
        }
      }).catch((err) => {
        this.stopProcessing();
        console.err(err)
      })
    },
    cursoFinalizado() {
      this.startProcessing();
      this.fetchCursoFinalizado().then((result) => {
        this.stopProcessing();
        if (result.codigo == 'inasistencia') {
          this.mensaje = result.mensaje;
          this.paso = 5;
        } else if (!result || (result && !result.dato)) {
          this.$router.push(`/`)
        } else {
          this.codigo = result.codigo;
          this.mensaje = result.mensaje;
          this.virtual = result.dato ? result.dato.virtual : false;
          if (result.codigo == 'ok') {
            this.nivel_siguiente = result.dato.nivel_siguiente;
            this.paso = 1;
            this.consultarNotas();
          } else if (result.codigo == 'ok_update') {
            this.paso = 1;
            this.consultarNotas();
          } else {
            this.paso = 2;
          }
        }
      }).catch((err) => {
        this.stopProcessing();
        console.err(err)
      })
    },
    consultarNotas() {
      this.fetchInformacion().then((result) => {
        this.form = result;
      }).catch((error) => {
        console.error(error)
      })
    },
    establecerSedes() {
      this.sede_id = null;
      if (this.user && this.user.data && this.user.data.sede_id) {
        this.sede_id = this.user.data.sede_original_id;
        let sede = this.sedesFiltradas.find(x => x.id == this.user.data.sede_id);
        if (sede) {
          this.sede_id = sede.id;
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      siguienteTema: state => state.academico.siguienteTema,
      // sedeActual: state => state.academico.sedeActual, 
      // cursoActual: state => state.academico.cursoActual,
      // sedes: state  => state.sedes.lista,
      show_notification: state => state.show_notification,
      // curso_finalizado: state => state.academico.curso_finalizado, 
      sedes: state => state.sedes.lista,
    }),
    ...mapGetters({
      // getSede: 'sedes/getSede',
    }),
    // sedeOriginal(){
    //   return this.getSede(this.user.data.sede_original_id)
    // }, 
    validation() {
      return this.form.tipo_documento ? true : false
    },
    sedesFiltradas() {
      if (this.virtual) {
        return this.sedes.filter(element => {
          return element.es_virtual == 1
        })
      } else {
        return this.sedes.filter(element => {
          return element.es_virtual == 0
        })
      }
    },
    completo() {
      if (this.sede_id && this.nivel_siguiente) {
        return true;
      } else {
        return false;
      }
    }

  }

}
</script>

<style scoped>
/* ============================================================================
     CARD PRINCIPAL
     ============================================================================ */
.content-card {
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: var(--theme-shadow-md);
  max-width: 800px;
  margin: 0 auto;
}

/* ============================================================================
     CONTENIDO DE PASOS
     ============================================================================ */
.step-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ============================================================================
     CAJAS DE MENSAJE
     ============================================================================ */
.message-box {
  background: var(--theme-bg-tertiary);
  border-left: 4px solid var(--app-primary-blue);
  border-radius: 10px;
  padding: 1rem 1.25rem;
  color: var(--theme-text-primary);
  line-height: 1.6;
}

.message-box.error {
  border-left-color: var(--app-primary-red);
}

.message-box :deep(p) {
  margin-bottom: 0.5rem;
}

.message-box :deep(p:last-child) {
  margin-bottom: 0;
}

/* ============================================================================
     INFO DE NIVEL
     ============================================================================ */
.nivel-info {
  background: var(--theme-gradient-primary);
  color: white;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  text-align: center;
  font-size: 1.05rem;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.2);
}

.nivel-info strong {
  font-weight: 600;
  margin-right: 0.5rem;
}

/* ============================================================================
     SECCIÓN DE FORMULARIO
     ============================================================================ */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* ============================================================================
     CONFIRMACIÓN
     ============================================================================ */
.confirmation-section {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 0.5rem;
}

.confirmation-text {
  text-align: center;
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--theme-text-primary);
  margin: 0;
}

/* ============================================================================
     GRUPOS DE BOTONES
     ============================================================================ */
.button-group {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 0.5rem;
}

.button-group.centered {
  margin-top: 0;
}

.button-group .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 140px;
  min-height: 42px;
  padding: 0.625rem 1.25rem;
  border: 1px solid transparent;
  border-radius: 10px;
  box-shadow: var(--theme-shadow-sm);
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.button-group .btn i {
  font-size: 1rem;
}

.button-group .btn-success {
  background: var(--app-color-green);
  border-color: var(--app-color-green);
  color: var(--app-header-text);
}

.button-group .btn-danger {
  background: var(--app-primary-red);
  border-color: var(--app-primary-red);
  color: var(--app-header-text);
}

.button-group .btn-primary {
  background: var(--theme-gradient-primary);
  border-color: var(--app-primary-blue);
  color: var(--app-header-text);
}

.button-group .btn:hover:not(:disabled),
.button-group .btn:focus:not(:disabled) {
  color: var(--app-header-text);
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
}

.button-group .btn:focus {
  outline: 2px solid var(--app-primary-blue);
  outline-offset: 2px;
}

.button-group .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* ============================================================================
     RESPONSIVE
     ============================================================================ */
@media (max-width: 768px) {
  .content-card {
    padding: 1.5rem;
    border-radius: 12px;
  }

  .step-content {
    gap: 1.25rem;
  }

  .message-box {
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
  }

  .nivel-info {
    padding: 0.875rem 1rem;
    font-size: 1rem;
  }

  .button-group {
    flex-direction: column;
    gap: 0.75rem;
  }

  .button-group .btn {
    width: 100%;
    min-width: unset;
  }
}

@media (max-width: 480px) {
  .content-card {
    padding: 1rem;
  }

  .step-content {
    gap: 1rem;
  }

  .message-box {
    padding: 0.75rem 0.875rem;
    font-size: 0.9rem;
  }

  .nivel-info {
    padding: 0.75rem 0.875rem;
    font-size: 0.95rem;
  }

  .confirmation-text {
    font-size: 1rem;
  }

  .button-group .btn {
    padding: 0.625rem 1rem;
    font-size: 0.95rem;
  }
}
</style>